module.exports = __webpack_public_path__ + "static/media/schedule.4d77224c.svg";